import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-roboto lg:pl-72 pb-16" }
const _hoisted_2 = {
  key: 0,
  class: "px-4 sm:px-6 lg:px-8 mt-6 mx-8 border border-gray-900/5 rounded-md shadow-sm"
}
const _hoisted_3 = { class: "flex justify-between gap-x-4 mt-8" }
const _hoisted_4 = { class: "flex justify-start" }
const _hoisted_5 = {
  class: "relative",
  action: "#",
  method: "GET"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "search-field",
  class: "sr-only"
}, "Search", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-5 py-3 h-full absolute left-1",
  src: "/img/Icons/Magnifying_glass.svg",
  alt: "Search Icon"
}, null, -1)
const _hoisted_8 = { class: "-mx-4 mt-8 sm:-mx-0" }
const _hoisted_9 = { class: "min-w-full divide-y divide-gray-300" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-dark-blue sm:pl-0 flex items-center"
    }, " Campaign Name "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3.5 text-left text-sm font-semibold text-dark-blue sm:table-cell"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, " Campaign Type ")
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "hidden px-3 py-3.5 text-left text-sm font-semibold text-dark-blue lg:table-cell"
    }, "Status"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3.5 text-left text-sm font-semibold text-dark-blue"
    }, "Created By"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3.5 text-left text-sm font-semibold text-dark-blue"
    }, "Created At"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "relative py-3.5 pl-3 pr-4 sm:pr-0"
    }, [
      /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Edit")
    ])
  ])
], -1)
const _hoisted_11 = { class: "divide-y divide-gray-200 bg-white" }
const _hoisted_12 = { class: "whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0" }
const _hoisted_13 = { class: "hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 sm:table-cell" }
const _hoisted_14 = { class: "hidden whitespace-nowrap px-3 py-4 text-sm lg:table-cell" }
const _hoisted_15 = { class: "hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 sm:table-cell" }
const _hoisted_16 = { class: "hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 sm:table-cell" }
const _hoisted_17 = { class: "whitespace-nowrap py-4 text-sm font-medium sm:pr-0" }
const _hoisted_18 = ["href"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "sr-only" }
const _hoisted_21 = {
  key: 0,
  class: "absolute right-0 top-full w-40 z-10 mt-2 bg-white border border-gray-300 rounded-md shadow-md"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Campaign Details", -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 1,
  class: "mt-6 mx-8"
}
const _hoisted_26 = { class: "border border-gray-900/5 rounded-md shadow-sm max-w-7xl px-4 sm:px-6 sm:py-12 lg:px-8" }
const _hoisted_27 = { class: "flex justify-between" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("img", {
  class: "mr-1",
  src: "/img/Icons/Back_arrow.svg",
  alt: "Back"
}, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h1", { class: "text-sm text-dark-blue" }, "Back", -1)
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = { class: "flex" }
const _hoisted_32 = { class: "mt-8" }
const _hoisted_33 = { class: "space-y-24" }
const _hoisted_34 = { class: "grid grid-cols-1 text-sm sm:grid-cols-12 sm:grid-rows-1 sm:gap-x-6 md:gap-x-8 lg:gap-x-8" }
const _hoisted_35 = { class: "sm:col-span-4 md:col-span-5 md:row-span-2 md:row-end-2" }
const _hoisted_36 = { class: "aspect-h-1 aspect-w-1 overflow-hidden rounded-lg bg-gray-50" }
const _hoisted_37 = ["src"]
const _hoisted_38 = { class: "mt-6 sm:col-span-7 sm:mt-0 md:row-end-1" }
const _hoisted_39 = { class: "text-2xl font-bold text-dark-blue" }
const _hoisted_40 = { class: "mt-2 font-medium text-gray-500" }
const _hoisted_41 = { class: "mt-1 text-gray-500" }
const _hoisted_42 = { class: "sm:col-span-12 md:col-span-7" }
const _hoisted_43 = { class: "flex my-4" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", { class: "text-dark-blue text-base" }, "Start Date", -1)
const _hoisted_45 = { class: "text-dark-blue text-sm mt-1.5" }
const _hoisted_46 = { class: "ml-14" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", { class: "text-dark-blue text-base" }, "End Date", -1)
const _hoisted_48 = { class: "text-dark-blue text-sm mt-1.5" }
const _hoisted_49 = { class: "flex mt-1" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("p", { class: "mr-2 text-lg font-medium text-dark-blue" }, "Total Funding Needed:", -1)
const _hoisted_51 = { class: "text-dark-blue text-lg" }
const _hoisted_52 = { class: "mt-4" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-bold text-dark-blue" }, "About This Campaign", -1)
const _hoisted_54 = { class: "mt-1.5" }

import AdminSidebar from '@/components/Layouts/AdminSidebar.vue'
import Toast from '@/helpers/Toast'
import Button from '@/components/Atomic/AQuarks/Button.vue'
import NotFound from '@/components/Atomic/BAtoms/NotFound.vue'
import {useCampaignStore} from '@/areas/campaigns/stores/campaignStore'
import {useSchoolStore} from '@/areas/schools/stores/schoolStore'
import {computed, onBeforeUnmount, onMounted, PropType, ref, watch} from 'vue';
import {CampaignDto} from '@/areas/campaigns/dtos/campaignDto';
import {SchoolDto} from '@/areas/schools/dtos/schoolDto'
import keycloak from '@/keycloak';
import {CampaignState} from '@/areas/campaigns/enums/campaignState'
import {formatDate} from "@/helpers/utilities/dataFormats";
import CampaignProgressBar from "@/components/Atomic/BAtoms/CampaignProgressBar.vue";
import {compareCampaignEntityState, getStatusClass} from "@/components/Atomic/BAtoms/campaigns/CampaignStateHelpers"
import CampaignStateFilterButtons from "@/components/Atomic/BAtoms/campaigns/CampaignStateFilterButtons.vue";
import PaginationV2 from "@/components/Atomic/AQuarks/PaginationV2.vue";
import {UserSearchDto} from "@/areas/users/dtos/userSearchDto";
import CampaignReinstateModal from "@/components/Atomic/BAtoms/campaigns/modals/CampaignReinstateModal.vue";
import CampaignPauseModal from "@/components/Atomic/BAtoms/campaigns/modals/CampaignPauseModal.vue";
import CampaignDeclineModal from "@/components/Atomic/BAtoms/campaigns/modals/CampaignDeclineModal.vue";
import CampaignApproveModal from "@/components/Atomic/BAtoms/campaigns/modals/CampaignApproveModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ManageCampaigns',
  props: {
  searchDto: {
    type: Object as PropType<UserSearchDto>,
    default: {
      pageSize: 7,
      pageNumber: 1,
    }
  }
},
  setup(__props) {

const props = __props

const searchDto = ref(props.searchDto)
const campaigns = ref<CampaignDto[]>()
const school = ref<SchoolDto>()
const campaignStore = useCampaignStore()
const schoolStore = useSchoolStore()

// TODO: Update hte ordering of this list to be more intuitive
const campaignStateOptions = ref<string[]>([CampaignState.Active, CampaignState.Pending, CampaignState.Paused, CampaignState.Declined, CampaignState.Completed])

let searchTerm = ref<string>('');
let currentFilter = ref<string>('');
let isPaused = ref<boolean>(false);
let declineButtonClicked = ref<boolean>(false);
let showApproveModal = ref<boolean>(false);
let showApproveModalTriggered = ref<boolean>(false);
let showDeclineModal = ref<boolean>(false)
let showPauseModal = ref<boolean>(false)
let showReinstateModal = ref<boolean>(false)
let showCampaignDetails = ref<boolean>(false)
let showSearchField = ref<boolean>(true)
let pageTitle = ref<string>('Campaign Management')
let selectedCampaign = ref<CampaignDto | null>(null);

let schoolGuid = keycloak.tokenParsed!.SchoolAdmin

const fetchCampaigns = async () => {
  let schoolFetchResult = await schoolStore.schoolByGuid(schoolGuid)
  
  if(schoolFetchResult.isSuccessful) 
  {
    school.value = schoolFetchResult.content
  }
  
  let campaignFetchResult = await campaignStore.listCampaignsBySchool(schoolGuid);
  
  if(campaignFetchResult.isSuccessful) 
  {
    searchDto.value.totalPages = Math.ceil(campaignFetchResult.content!.length / searchDto.value.pageSize)
    searchDto.value.totalEntities = campaignFetchResult.content!.length
    
    // This orders based on state and then alphabetically if the states are the same
    campaigns.value = campaignFetchResult.content!.sort((a,b) => {
      if (a.entityState === b.entityState){
        return a.displayName.localeCompare(b.displayName)
      }
      return compareCampaignEntityState(a.entityState, b.entityState)
    })
  }
}

const getCoverPhotoLink = (campaign: CampaignDto) => {
  const coverPhotoAsset = campaign.campaignAssets.find(asset => asset.assetType === 'CoverPhoto');
  return coverPhotoAsset ? coverPhotoAsset.preSignedLink : '/img/image.svg';
}

const filteredCampaigns = computed<CampaignDto[]>(() => {
  let filtered: CampaignDto[] = [];
  if (campaigns.value) {
    filtered = campaigns.value;
    if (currentFilter.value) {
      filtered = filtered.filter(campaign => campaign.entityState === currentFilter.value);
    }
    if (searchTerm.value) {
      filtered = filtered.filter(campaign => campaign.displayName.toLowerCase().includes(searchTerm.value.toLowerCase()));
      searchDto.value.pageNumber = 1;
    }
  }

  searchDto.value.totalPages = Math.ceil(filtered.length / searchDto.value.pageSize)
  
  return filtered;
});

const paginatedCampaigns = computed(() => {
  let start = (searchDto.value.pageNumber - 1) * searchDto.value.pageSize
  let end = start + searchDto.value.pageSize
  
  return filteredCampaigns.value.slice(start, end)
})

// Modal functions
const approveCampaign = async () => {
  let approveCampaignResult = await campaignStore.updateCampaignState(schoolGuid, selectedCampaign.value!.guid, CampaignState.Active)
  
  if(approveCampaignResult.isSuccessful){
    Toast.success("Campaign Successfully Approved")
    selectedCampaign.value = approveCampaignResult.content!
  }
  
  showApproveModal.value = false
  showReinstateModal.value = false
  location.reload()
}

const declineCampaign = async () => {
  let approveCampaignResult = await campaignStore.updateCampaignState(schoolGuid, selectedCampaign.value!.guid, CampaignState.Declined)
  
  if (approveCampaignResult.isSuccessful){
    Toast.success("Campaign Successfully Declined")
    selectedCampaign.value = approveCampaignResult.content!
  }
  
  showDeclineModal.value = false
  location.reload()
}

const pauseCampaign = async () => {
  let approveCampaignResult = await campaignStore.updateCampaignState(schoolGuid, selectedCampaign.value!.guid, CampaignState.Paused)
  
  if (approveCampaignResult.isSuccessful){
    Toast.success("Campaign Successfully Paused")
    selectedCampaign.value = approveCampaignResult.content!
  }
  
  showPauseModal.value = false
  location.reload()
}

const handleClickOutside = (event: MouseEvent) => {
  // Cast the target of the event to an Element to access DOM properties
  const targetElement = event.target as Element;
  
  if(targetElement.id !== 'kebab'){
    closeAllKebabMenus();
  }
};

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
  fetchCampaigns();
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside);
})

// Pagination
watch(() => currentFilter.value, (newValue) => {
  if (searchDto.value){
    searchDto.value!.pageNumber = 1
  }
})

const totalPages = computed(() => {
  if (campaigns.value && campaigns.value?.length > 0){
    return filteredCampaigns.value ? Math.ceil(filteredCampaigns.value!.length / searchDto.value!.pageSize) : 0
  }
})

const paginatedSchools = computed(() => {
  let start = (searchDto.value.pageNumber - 1) * searchDto.value.pageSize
  let end = start + searchDto.value.pageSize
  return filteredCampaigns.value.slice(start, end)
})

const handlePageChange = async (newPage: number) => {
  if (searchDto.value?.totalPages && newPage <= searchDto.value.totalPages && newPage > 0){
    searchDto.value!.pageNumber = newPage
  }
}

// --- end pagination
const filterCampaigns = (status: string) => {
  currentFilter.value = status;
  searchDto.value.pageNumber = 1;
}

const showCampaignDetailsPage = (campaign: CampaignDto) => {
  pageTitle.value = 'Campaign Details'
  campaign.showKebabMenu = false
  showCampaignDetails.value = true;
  showSearchField.value = false;
  selectedCampaign.value = campaign;
}

const goBackFromCampaignDetails = () => {
  pageTitle.value = 'Campaign Management'
  showCampaignDetails.value = false;
  showSearchField.value = true;

  campaigns.value!.forEach((campaign) => {
    campaign.showKebabMenu = false;
    campaign.showDropdown = false;
  });
}

const closeAllKebabMenus = () => {
  const openMenus = campaigns.value!.filter(campaign => campaign.showKebabMenu)
  openMenus.forEach(campaign => campaign.showKebabMenu = false)
}

const toggleKebabMenu = (campaign: CampaignDto) => {
  closeAllKebabMenus()
  campaign.showKebabMenu = true
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AdminSidebar, {
      showSearchField: _unref(showSearchField),
      pageTitle: _unref(pageTitle)
    }, null, 8, ["showSearchField", "pageTitle"]),
    _createElementVNode("div", _hoisted_1, [
      (!_unref(showCampaignDetails))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("form", _hoisted_5, [
                  _hoisted_6,
                  _hoisted_7,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchTerm) ? (searchTerm).value = $event : searchTerm = $event)),
                    id: "search-field",
                    class: "h-full w-80 border border-dark-blue rounded-md py-3 pl-8 pr-0 text-dark-blue placeholder:text-gray-400 sm:text-sm outline-none",
                    placeholder: "Search Campaign Name..."
                  }, null, 512), [
                    [_vModelText, _unref(searchTerm)]
                  ])
                ])
              ]),
              _createVNode(CampaignStateFilterButtons, {
                onUpdate: _cache[1] || (_cache[1] = ($event: any) => (_isRef(currentFilter) //@ts-ignore
 ? currentFilter.value = $event : currentFilter = $event)),
                "style-class": 'flex justify-end gap-x-4',
                "type-options": campaignStateOptions.value,
                "model-value": _unref(currentFilter)
              }, null, 8, ["type-options", "model-value"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("table", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("tbody", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedCampaigns.value, (campaign, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_12, _toDisplayString(campaign.displayName), 1),
                      _createElementVNode("td", _hoisted_13, _toDisplayString(campaign.campaignType), 1),
                      _createElementVNode("td", _hoisted_14, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["px-2.5 py-1.5 rounded-md", _unref(getStatusClass)(campaign.entityState)])
                        }, _toDisplayString(campaign.entityState), 3)
                      ]),
                      _createElementVNode("td", _hoisted_15, _toDisplayString(campaign.creator?.firstName ?? '') + " " + _toDisplayString(campaign.creator?.lastName ?? ''), 1),
                      _createElementVNode("td", _hoisted_16, _toDisplayString(_unref(formatDate)(campaign.createdAt)), 1),
                      _createElementVNode("td", _hoisted_17, [
                        _createElementVNode("a", {
                          href: `#/edit/${campaign.guid}`,
                          class: "relative inline-block"
                        }, [
                          _createElementVNode("img", {
                            src: "/img/Icons/kebab_menu.svg",
                            id: "kebab",
                            alt: "Menu",
                            onClick: ($event: any) => (toggleKebabMenu(campaign)),
                            class: "cursor-pointer"
                          }, null, 8, _hoisted_19),
                          _createElementVNode("span", _hoisted_20, ", " + _toDisplayString(campaign.displayName), 1),
                          (campaign.showKebabMenu)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _createElementVNode("div", {
                                  onClick: ($event: any) => (showCampaignDetailsPage(campaign)),
                                  class: "cursor-pointer px-3 py-2 hover:bg-[#DBEAFE]"
                                }, _hoisted_24, 8, _hoisted_22)
                              ]))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_18)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(showCampaignDetails))
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("a", {
                  onClick: goBackFromCampaignDetails,
                  class: "flex items-center cursor-pointer"
                }, _hoisted_30),
                _createElementVNode("div", _hoisted_31, [
                  (_unref(selectedCampaign).entityState === 'Pending' && !_unref(showApproveModalTriggered))
                    ? (_openBlock(), _createBlock(Button, {
                        key: 0,
                        buttonText: "Approve",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => {_isRef(showApproveModal) //@ts-ignore
 ? showApproveModal.value = true : showApproveModal = true;}),
                        class: "ml-2 px-8 py-1.5 bg-green text-white rounded-md shadow-md"
                      }))
                    : _createCommentVNode("", true),
                  (_unref(selectedCampaign).entityState === 'Pending' && !_unref(showApproveModalTriggered) && !_unref(declineButtonClicked))
                    ? (_openBlock(), _createBlock(Button, {
                        key: 1,
                        buttonText: "Decline",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_isRef(showDeclineModal) //@ts-ignore
 ? showDeclineModal.value = true : showDeclineModal = true)),
                        class: "ml-2 px-8 py-1.5 bg-orange-red text-white rounded-md shadow-md"
                      }))
                    : _createCommentVNode("", true),
                  (!_unref(isPaused) && _unref(selectedCampaign).entityState === 'Active')
                    ? (_openBlock(), _createBlock(Button, {
                        key: 2,
                        buttonText: "Pause",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_isRef(showPauseModal) //@ts-ignore
 ? showPauseModal.value = true : showPauseModal = true)),
                        class: "ml-2 px-8 py-1.5 bg-light-blue text-white rounded-md shadow-md"
                      }))
                    : _createCommentVNode("", true),
                  (_unref(isPaused) || _unref(selectedCampaign).entityState === 'Paused')
                    ? (_openBlock(), _createBlock(Button, {
                        key: 3,
                        buttonText: "Reinstate",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_isRef(showReinstateModal) //@ts-ignore
 ? showReinstateModal.value = true : showReinstateModal= true)),
                        class: "ml-2 px-8 py-1.5 bg-light-blue text-white rounded-md shadow-md"
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("img", {
                          src: getCoverPhotoLink(_unref(selectedCampaign)!),
                          alt: "Campaign Cover Photo",
                          class: "object-cover object-center w-full"
                        }, null, 8, _hoisted_37)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("h3", _hoisted_39, _toDisplayString(_unref(selectedCampaign)!.displayName), 1),
                      _createElementVNode("p", _hoisted_40, _toDisplayString(school.value?.name), 1),
                      _createElementVNode("p", _hoisted_41, _toDisplayString(school.value?.address.city) + ", " + _toDisplayString(school.value?.address.province), 1)
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", null, [
                          _hoisted_44,
                          _createElementVNode("p", _hoisted_45, _toDisplayString(_unref(formatDate)(_unref(selectedCampaign).startDate!)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          _hoisted_47,
                          _createElementVNode("p", _hoisted_48, _toDisplayString(_unref(formatDate)(_unref(selectedCampaign).endDate!)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _hoisted_50,
                        _createElementVNode("span", _hoisted_51, "R" + _toDisplayString(_unref(selectedCampaign)?.targetAmount || 0), 1)
                      ]),
                      _createVNode(CampaignProgressBar, {
                        "target-amount": _unref(selectedCampaign).targetAmount,
                        "cumulative-donations": _unref(selectedCampaign).cumulativeDonations
                      }, null, 8, ["target-amount", "cumulative-donations"]),
                      _createElementVNode("div", _hoisted_52, [
                        _hoisted_53,
                        _createElementVNode("p", _hoisted_54, _toDisplayString(_unref(selectedCampaign).story), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(showApproveModal))
        ? (_openBlock(), _createBlock(CampaignApproveModal, {
            key: 2,
            name: _unref(selectedCampaign) ? _unref(selectedCampaign).displayName : '',
            onToggleApproveModal: _cache[6] || (_cache[6] = ($event: any) => (_isRef(showApproveModal) //@ts-ignore
 ? showApproveModal.value = false : showApproveModal = false)),
            onApproveCampaign: approveCampaign
          }, null, 8, ["name"]))
        : _createCommentVNode("", true),
      (_unref(showDeclineModal))
        ? (_openBlock(), _createBlock(CampaignDeclineModal, {
            key: 3,
            name: _unref(selectedCampaign) ? _unref(selectedCampaign).displayName : '',
            onToggleDeclineModal: _cache[7] || (_cache[7] = ($event: any) => (_isRef(showDeclineModal) //@ts-ignore
 ? showDeclineModal.value = false : showDeclineModal = false)),
            onDeclineCampaign: declineCampaign
          }, null, 8, ["name"]))
        : _createCommentVNode("", true),
      (_unref(showPauseModal))
        ? (_openBlock(), _createBlock(CampaignPauseModal, {
            key: 4,
            name: _unref(selectedCampaign) ? _unref(selectedCampaign).displayName : '',
            onTogglePauseModal: _cache[8] || (_cache[8] = ($event: any) => (_isRef(showPauseModal) //@ts-ignore
 ? showPauseModal.value = false : showPauseModal = false)),
            onPauseCampaign: pauseCampaign
          }, null, 8, ["name"]))
        : _createCommentVNode("", true),
      (_unref(showReinstateModal))
        ? (_openBlock(), _createBlock(CampaignReinstateModal, {
            key: 5,
            name: _unref(selectedCampaign) ? _unref(selectedCampaign).displayName : '',
            onToggleApproveModal: _cache[9] || (_cache[9] = ($event: any) => (_isRef(showReinstateModal) //@ts-ignore
 ? showReinstateModal.value = false : showReinstateModal = false)),
            onReinstateCampaign: approveCampaign
          }, null, 8, ["name"]))
        : _createCommentVNode("", true),
      (!_unref(showCampaignDetails) && filteredCampaigns.value.length === 0)
        ? (_openBlock(), _createBlock(NotFound, {
            key: 6,
            notFoundText: "No campaigns could be found"
          }))
        : _createCommentVNode("", true),
      (!_unref(showCampaignDetails) && searchDto.value.totalEntities)
        ? (_openBlock(), _createBlock(PaginationV2, {
            key: 7,
            onChange: handlePageChange,
            "search-dto": searchDto.value
          }, null, 8, ["search-dto"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})